
import './App.css';
import {Route, Routes, HashRouter} from "react-router-dom"
import BLogin from "./page/login/login.jsx"
import Admin from "./page/admin/index.jsx"

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes >
          <Route path="/login" element={<BLogin/>}></Route>
          <Route path="*" element={<Admin/>}></Route>
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
